var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTour = function SvgTour(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2834_6435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 15.8337C2.5 16.2757 2.67559 16.6996 2.98816 17.0122C3.30072 17.3247 3.72464 17.5003 4.16667 17.5003C4.60869 17.5003 5.03262 17.3247 5.34518 17.0122C5.65774 16.6996 5.83333 16.2757 5.83333 15.8337C5.83333 15.3916 5.65774 14.9677 5.34518 14.6551C5.03262 14.3426 4.60869 14.167 4.16667 14.167C3.72464 14.167 3.30072 14.3426 2.98816 14.6551C2.67559 14.9677 2.5 15.3916 2.5 15.8337Z",
    stroke: "#1565C0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8337 5.83333C16.2757 5.83333 16.6996 5.65774 17.0122 5.34518C17.3247 5.03262 17.5003 4.60869 17.5003 4.16667C17.5003 3.72464 17.3247 3.30072 17.0122 2.98816C16.6996 2.67559 16.2757 2.5 15.8337 2.5C15.3916 2.5 14.9677 2.67559 14.6551 2.98816C14.3426 3.30072 14.167 3.72464 14.167 4.16667C14.167 4.60869 14.3426 5.03262 14.6551 5.34518C14.9677 5.65774 15.3916 5.83333 15.8337 5.83333Z",
    stroke: "#1565C0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16699 15.8337H13.7503C14.5239 15.8337 15.2657 15.5264 15.8127 14.9794C16.3597 14.4324 16.667 13.6905 16.667 12.917C16.667 12.1434 16.3597 11.4016 15.8127 10.8546C15.2657 10.3076 14.5239 10.0003 13.7503 10.0003H7.08366C6.31011 10.0003 5.56825 9.69303 5.02126 9.14605C4.47428 8.59907 4.16699 7.85721 4.16699 7.08366C4.16699 6.31011 4.47428 5.56825 5.02126 5.02126C5.56825 4.47428 6.31011 4.16699 7.08366 4.16699H10.8337",
    stroke: "#1565C0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2834_6435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTour);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "tour.98705cc00e752721a54a3c38ff79fb66.svg";